import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FooterComponent } from './layout/footer/footer.component';
import { HeaderComponent } from './layout/header/header.component';
import { ActiveAgentsComponent } from '../core/main-widgets/active-agents/active-agents.component';

import { TrsSmTimerComponent } from 'src/app/modules/shared/layout/trs-sm-timer/trs-sm-timer.component';

import { RouterModule, Routes } from '@angular/router';
import { ConfirmBoxComponent } from './confirm-box/confirm-box.component'; 
import { NgxPaginationModule } from 'ngx-pagination';



const routes: Routes = [
  { path: 'logout', component: FooterComponent }
];

@NgModule({
  
  imports:  [ CommonModule, NgxPaginationModule, RouterModule.forRoot(routes) ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    ConfirmBoxComponent,
    TrsSmTimerComponent 
  ],
  providers:[
    ActiveAgentsComponent,  
    TrsSmTimerComponent
    
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    RouterModule,
    ConfirmBoxComponent,    
    TrsSmTimerComponent 
  ],
 

})
export class SharedModule { }
